import i18n from 'services/base/i18n';

export default {
  // Option that blocks the entire internet
  entireInternet: () => i18n.pgettext('Components|Parental Controls|Policies', 'Entire Internet'),
  // Option that blocks pornographic sites
  adultSites: () => i18n.pgettext('Components|Parental Controls|Policies', 'Adult Sites'),
  // Option that blocks social media (e.g. Facebook, Twitter)
  socialMedia: () => i18n.pgettext('Components|Parental Controls|Policies', 'Social Media'),
  // Option that blocks game websites (e.g. Steam, Kongregate, etc)
  gamingSites: () => i18n.pgettext('Components|Parental Controls|Policies', 'Games'),
  // Option that blocks entertainment websites (e.g. Netflix, Hulu)
  entertainmentSites: () => i18n.pgettext('Components|Parental Controls|Policies', 'Entertainment'),
  // Option that brings up a form to input a custom website to block
  customDomain: () => i18n.pgettext('Components|Parental Controls|Policies', 'Custom Website'),
  // Option that brings up a form to input a custom ip address to block
  customIP: () => i18n.pgettext('Components|Parental Controls|Policies', 'Custom IP Address'),
};
